const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_app/admin/offers/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { validateAdminOfferListSearch } from "@/routes/_app/admin/admin-offer-list-search";
import { adminPageTitle } from "@/routes/_app/admin/admin-page-title";
export const Route = createFileRoute("/_app/admin/offers/")({
  head: () => ({
    meta: [{
      title: adminPageTitle("Offers")
    }]
  }),
  validateSearch: validateAdminOfferListSearch,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});